import ContractingsSection from 'features/contracting/sections/ContractingsSection';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { loadPortalConfig } from 'features/shared/helpers/modules';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';

const portalConfig = loadPortalConfig();

const ContractingsAdminPage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // render
  return (
    <RenderWrapper isVisible={() => portalConfig.enableContracting}>
      <Header
          title={tLabels("contractingsAdminPage.title")}
          includeBreadcrumbs
      />
      <ModuleContent>
        <ContractingsSection forAdminUse />
      </ModuleContent>
    </RenderWrapper>
  );
}

export default ContractingsAdminPage;